import { render, staticRenderFns } from "./AdminIframe.vue?vue&type=template&id=6d8a3646&scoped=true&"
import script from "./AdminIframe.vue?vue&type=script&lang=ts&"
export * from "./AdminIframe.vue?vue&type=script&lang=ts&"
import style0 from "./AdminIframe.vue?vue&type=style&index=0&id=6d8a3646&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8a3646",
  null
  
)

export default component.exports